/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-delimiter-style */
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, throwError } from "rxjs";
import { ApiService } from "./api.service";
import { catchError } from "rxjs/operators";

@Injectable()
export class AppService {
    appVersion$: BehaviorSubject<{ APP_VERSION_ID: string, APP_VERSION_DISPLAY: string, APP_COMMIT_SHA: string }> = new BehaviorSubject({ APP_VERSION_ID: '0.0.0', APP_VERSION_DISPLAY: 'X', APP_COMMIT_SHA: 'Z' });
    
    constructor(
        private _httpClient: HttpClient, 
        private _apiService: ApiService
    ) {
    }

    getAppVersion() {
        return new Promise<void>((resolve, reject) => {
            this._httpClient.get<{ APP_VERSION_ID: string; APP_VERSION_DISPLAY: string, APP_COMMIT_SHA: string }>(this._apiService.endPoints.GetAppVersion).pipe(this.HandleNetworkError())
            .subscribe(
                (_appVersions: { APP_VERSION_ID: string; APP_VERSION_DISPLAY: string, APP_COMMIT_SHA: string }) => {
                    this.appVersion$.next(_appVersions);
                    resolve();
                },
                (_error) => {
                    reject(_error);
                }
            );
        });
    }

    HandleNetworkError() {
        return catchError(error => { 
            return throwError(!!error.error ? error.error.ErrorDescription : error.message); 
        });
    }
}
